module.exports = __webpack_public_path__ + "img/next-sub.5cdcfd38.svg";